import _defineProperty from "/jove-quote/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

var _HANDLE_SOURCE_MAP;

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { useState } from 'react';
import { Box } from '@mui/material';
import { AnimatePresence, motion } from 'framer-motion';
import { FormProvider, useForm } from 'react-hook-form';
import { RevealView } from '../../../portal/common/motion';
import { PortalLoginHandleSourceEnum, PortalLoginViewEnum } from '../types';
import EmailLoginForm from './EmailLoginForm';
import ForgotPasswordForm from './ForgotPasswordForm';
import ResetPasswordForm from './ResetPasswordForm';
import SignUpForm from './SignUpForm';
import TwoFactorAuthenticationForm from './TwoFactorAuthenticationForm';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var HANDLE_SOURCE_MAP = (_HANDLE_SOURCE_MAP = {}, _defineProperty(_HANDLE_SOURCE_MAP, PortalLoginHandleSourceEnum.ResetPassword, PortalLoginViewEnum.ResetPassword), _defineProperty(_HANDLE_SOURCE_MAP, PortalLoginHandleSourceEnum.SignUp, PortalLoginViewEnum.SignUp), _HANDLE_SOURCE_MAP);
var VIEW_TRANSITION = {
  initial: {
    opacity: 0,
    y: 12
  },
  animate: {
    opacity: 1,
    y: 0
  },
  exit: {
    opacity: 0,
    y: -12
  },
  transition: {
    duration: 0.3,
    ease: [0.22, 1, 0.36, 1]
  }
};

var LoginFormPanel = function LoginFormPanel(props) {
  var brandInfo = props.brandInfo,
      loginSource = props.loginSource,
      onSuccess = props.onSuccess,
      onForgotPassword = props.onForgotPassword,
      onGoogleLogin = props.onGoogleLogin,
      onBack = props.onBack,
      slug = props.slug,
      email = props.email,
      handleSource = props.handleSource,
      token = props.token;

  var _useState = useState(HANDLE_SOURCE_MAP[handleSource] || PortalLoginViewEnum.Login),
      view = _useState[0],
      setView = _useState[1];

  var _useState2 = useState(null),
      pendingLoginPayload = _useState2[0],
      setPendingLoginPayload = _useState2[1];

  var _useState3 = useState(false),
      unregisteredEmailDetected = _useState3[0],
      setUnregisteredEmailDetected = _useState3[1];

  var _useState4 = useState(false),
      autoLoginOnce = _useState4[0],
      setAutoLoginOnce = _useState4[1];

  var methods = useForm({
    defaultValues: {
      email: email || '',
      password: '',
      token: token || '',
      twoFactorCode: '',
      slug: slug || '',
      loginSource: loginSource,
      handleSource: handleSource,
      brandInfo: brandInfo
    }
  });
  /**
   * methods
   */

  var showLoginViewAction = function showLoginViewAction() {
    setUnregisteredEmailDetected(false);
    setAutoLoginOnce(false);
    setPendingLoginPayload(null);
    setView(PortalLoginViewEnum.Login);
  };

  var loginSuccessAction = function loginSuccessAction(payload) {
    if (props.twoFactorAuthenticationEnabled) {
      setPendingLoginPayload(payload);
      setView(PortalLoginViewEnum.TwoFactorAuthentication);
      return;
    }

    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(payload);
  };

  var completeLoginAction = function completeLoginAction() {
    if (!pendingLoginPayload) return;
    onSuccess === null || onSuccess === void 0 ? void 0 : onSuccess(pendingLoginPayload);
    setPendingLoginPayload(null);
  };

  var registerSuccessAutoLoginAction = function registerSuccessAutoLoginAction() {
    setUnregisteredEmailDetected(false);
    setAutoLoginOnce(true);
    setView(PortalLoginViewEnum.Login);
  };

  var showSignUpViewAction = function showSignUpViewAction(autoDetectedUnregisteredEmail) {
    setUnregisteredEmailDetected(!!autoDetectedUnregisteredEmail);
    setView(PortalLoginViewEnum.SignUp);
  };

  var showForgotPasswordViewAction = function showForgotPasswordViewAction() {
    setView(PortalLoginViewEnum.ForgotPassword);
  };

  return /*#__PURE__*/_jsx(Box, {
    className: "flex w-full flex-1 flex-col justify-center px-4 py-12 md:px-10 md:py-16",
    children: /*#__PURE__*/_jsx(FormProvider, _objectSpread(_objectSpread({}, methods), {}, {
      children: /*#__PURE__*/_jsx(RevealView, {
        direction: "right",
        className: "mx-auto w-full max-w-[440px]",
        children: /*#__PURE__*/_jsxs(AnimatePresence, {
          mode: "wait",
          initial: false,
          children: [view === PortalLoginViewEnum.Login && /*#__PURE__*/_jsx(motion.div, _objectSpread(_objectSpread({}, VIEW_TRANSITION), {}, {
            children: /*#__PURE__*/_jsx(EmailLoginForm, {
              autoLoginOnce: autoLoginOnce,
              onSuccess: loginSuccessAction,
              onForgotPassword: showForgotPasswordViewAction,
              onSignUp: showSignUpViewAction,
              onGoogleLogin: onGoogleLogin,
              onBack: onBack
            })
          }), "login"), view === PortalLoginViewEnum.TwoFactorAuthentication && /*#__PURE__*/_jsx(motion.div, _objectSpread(_objectSpread({}, VIEW_TRANSITION), {}, {
            children: /*#__PURE__*/_jsx(TwoFactorAuthenticationForm, {
              onVerified: completeLoginAction,
              onSkip: completeLoginAction,
              onBackToLogin: showLoginViewAction
            })
          }), "twoFactorAuthentication"), view === PortalLoginViewEnum.SignUp && /*#__PURE__*/_jsx(motion.div, _objectSpread(_objectSpread({}, VIEW_TRANSITION), {}, {
            children: /*#__PURE__*/_jsx(SignUpForm, {
              unregisteredEmailDetected: unregisteredEmailDetected,
              onRegister: registerSuccessAutoLoginAction,
              onLogIn: showLoginViewAction
            })
          }), "signUp"), view === PortalLoginViewEnum.ForgotPassword && /*#__PURE__*/_jsx(motion.div, _objectSpread(_objectSpread({}, VIEW_TRANSITION), {}, {
            children: /*#__PURE__*/_jsx(ForgotPasswordForm, {
              onSend: onForgotPassword,
              onBackToLogin: showLoginViewAction
            })
          }), "forgotPassword"), view === PortalLoginViewEnum.ResetPassword && /*#__PURE__*/_jsx(motion.div, _objectSpread(_objectSpread({}, VIEW_TRANSITION), {}, {
            children: /*#__PURE__*/_jsx(ResetPasswordForm, {
              onResetPassword: showLoginViewAction,
              onBackToLogin: showLoginViewAction
            })
          }), "resetPassword")]
        })
      })
    }))
  });
};

export default LoginFormPanel;